/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-return-await */
import React, { useState } from 'react'
import axios from 'axios'
import { useAuth0 } from '@auth0/auth0-react'
import {
  Button,
  Grid,
  Modal,
  Popover,
  Radio,
  Text,
  Textarea,
  useModal,
} from '@geist-ui/react'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import HelpCircle from '@geist-ui/react-icons/helpCircle'
import Link from 'next/link'
import Logo from 'components/Logo'

import { useProfile, useToken } from 'hooks'

export default function TopBar() {
  const { logout } = useAuth0()
  const { headers } = useToken()
  const { profile } = useProfile()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false)
  const [radioState, setRadioState] = useState(
    'I am cancelling my Louisville Water service'
  )
  const [textState, setTextState] = useState('')

  const { visible, setVisible, bindings } = useModal()

  const completeCancellation = () => {
    if (!profile || !headers) {
      return
    }
    const date = new Date()

    const update = {
      account_id: profile?.account_id,
      account_address: profile?.account_address,
      transaction_code: '3',
      cancellation_date: date,
      cancellation_reason: radioState === 'Other' ? textState : radioState,
    }

    axios({
      method: 'put',
      url: `${process.env.NEXT_PUBLIC_API_URL}/enrollment`,
      headers,
      data: update,
    }).then(() => {
      handleLogout()
    })
  }

  const completeReEnrollment = async () => {
    if (!profile || !headers) {
      return
    }
    const update = {
      account_id: profile?.account_id,
      account_address: profile?.account_address,
      transaction_code: '1',
      cancellation_date: '',
    }
    await axios({
      method: 'put',
      url: `${process.env.NEXT_PUBLIC_API_URL}/enrollment`,
      headers,
      data: update,
    })
      .then(() => {
        window.location.reload()
      })
      .catch((e) => e)
  }

  const handleLogout = () => {
    logout({ returnTo: window.location.origin })
  }

  const initiateCancel = () => {
    setVisible(true)
  }

  const support = () => (
    <>
      <Popover.Item style={{ cursor: 'pointer' }}>888-977-7481</Popover.Item>
      <Popover.Item style={{ cursor: 'pointer' }}>
        info@waterproplan.com
      </Popover.Item>
    </>
  )

  const isCancelled = profile?.transaction_code === '3'

  const actionButton = profile ? (
    <Button
      className="dropdownItem"
      onClick={isCancelled ? completeReEnrollment : initiateCancel}
      style={{ color: '#0070f3' }}
      disabled={!headers}
    >
      {isCancelled ? 'Re-Enroll' : 'Cancel Services'}
    </Button>
  ) : null

  return (
    <>
      <Grid.Container
        alignItems="center"
        justify="space-between"
        style={{
          padding: '10px 20px',
          borderBottom: '1px solid rgba(0,0,0,.075)',
          boxShadow: '1px 1px 20px rgba(0,0,0,.05)',
          background: '#fff',
          position: 'fixed',
          top: '0',
          zIndex: '9999',
        }}
      >
        <Grid xs={0} sm={3}>
          <Logo />
        </Grid>
        <Grid xs={0} sm justify="flex-end">
          <Popover content={support}>
            <Button
              auto
              width="30%"
              scale={0.7}
              type="abort"
              icon={<HelpCircle />}
            >
              Support
            </Button>
          </Popover>
          <DropdownMenu.Root open={dropdownOpen} onOpenChange={setDropdownOpen}>
            <DropdownMenu.Trigger asChild>
              <Button auto scale={0.75}>
                Your account
              </Button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Portal>
              <DropdownMenu.Content
                className="DropdownMenuContent"
                sideOffset={5}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  boxShadow:
                    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
                  animationDuration: '400ms',
                  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
                  willChange: 'transform, opacity',
                  zIndex: 10000,
                }}
              >
                {actionButton && (
                  <DropdownMenu.Item className="DropdownMenuItem">
                    {actionButton}
                  </DropdownMenu.Item>
                )}
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button
                    type="error"
                    className="dropdownItem error"
                    onClick={handleLogout}
                  >
                    Sign out
                  </Button>
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        </Grid>
      </Grid.Container>

      {/* START MOBILE */}

      <Grid.Container
        sm={0}
        alignItems="center"
        justify="space-between"
        style={{
          padding: '10px 10px 10px 20px',
          borderBottom: '1px solid rgba(0,0,0,.075)',
          boxShadow: '1px 1px 20px rgba(0,0,0,.05)',
          background: '#fff',
          position: 'fixed',
          top: '0',
          zIndex: '9999',
        }}
      >
        <Grid sm={0}>
          <Logo height="30px" />
        </Grid>
        <Grid justify="end" xs={12} sm={0}>
          <DropdownMenu.Root
            open={mobileDropdownOpen}
            onOpenChange={setMobileDropdownOpen}
          >
            <DropdownMenu.Trigger asChild>
              <Button auto type="success-light" scale={0.75}>
                Menu
              </Button>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
              <DropdownMenu.Content
                className="DropdownMenuContent"
                sideOffset={5}
                style={{
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  boxShadow:
                    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',
                  animationDuration: '400ms',
                  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
                  willChange: 'transform, opacity',
                  zIndex: 10000,
                }}
              >
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem first">
                    <Link href="/" onClick={() => setDropdownOpen(false)}>
                      Submit a claim
                    </Link>
                  </Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">888-977-7481</Button>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button className="dropdownItem">
                    info@waterproplan.com
                  </Button>
                </DropdownMenu.Item>
                {actionButton && (
                  <DropdownMenu.Item className="DropdownMenuItem">
                    {actionButton}
                  </DropdownMenu.Item>
                )}
                <DropdownMenu.Item className="DropdownMenuItem">
                  <Button
                    type="error"
                    className="dropdownItem error"
                    onClick={handleLogout}
                  >
                    Sign out
                  </Button>
                </DropdownMenu.Item>
              </DropdownMenu.Content>
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
        </Grid>
      </Grid.Container>
      <Modal {...bindings}>
        <Modal.Title>Sad to see you go!</Modal.Title>
        <Modal.Content>
          <Text h5 style={{ marginBottom: '1.25rem', textAlign: 'center' }}>
            What is the biggest reason you wish to cancel?
          </Text>
          <Radio.Group
            value={radioState}
            onChange={(val) => setRadioState(val)}
          >
            <Radio value="I am cancelling my Louisville Water service">
              I am cancelling my Louisville Water service
            </Radio>
            <Radio value="I need a less expensive option">
              I need a less expensive option
            </Radio>
            <Radio value="The service is missing a feature I want">
              The service is missing a feature I want
            </Radio>
            <Radio value="I do not see the value in the product">
              I do not see the value in the product
            </Radio>
            <Radio value="I had technical problems">
              I had technical problems
            </Radio>
            <Radio value="I had an issue with billing/support">
              I had an issue with billing/support
            </Radio>
            <Radio value="I had an issue with the claim process">
              I had an issue with the claim process
            </Radio>

            <Radio value="Other" style={{ marginBottom: '2rem' }}>
              Other
            </Radio>
            <Textarea
              value={textState}
              onChange={(e) => setTextState(e.target.value)}
            />
          </Radio.Group>
        </Modal.Content>
        <Modal.Action passive onClick={() => setVisible(false)}>
          Go back
        </Modal.Action>
        <Modal.Action
          style={{ color: 'red' }}
          onClick={completeCancellation}
          disabled={radioState === 'Other' && !textState}
        >
          Delete account
        </Modal.Action>
      </Modal>
    </>
  )
}
